import { Link, Paragraph } from '@vimeo/iris/typography';

export default function Categories() {
  return (
    <div>
      <Paragraph size="2">
        <em>Categories</em> on Vimeo are sets of videos for particular genres (like comedy) or other
        characteristics (like being experimental). All the videos in these sets have been
        hand-chosen by Vimeo staff, but you can bring your videos to our attention by recommending
        them for up to two main categories and one subcategory. See our{' '}
        <Link
          variant="minimal"
          href="https://help.vimeo.com/hc/en-us/articles/12426157049105-Categories-and-tags"
        >
          Help Center
        </Link>{' '}
        for more details.
      </Paragraph>

      <Paragraph size="2">Use the API to complete the following tasks:</Paragraph>
    </div>
  );
}
